import { defineComponent as q, ref as c, computed as s, watch as G, openBlock as o, createElementBlock as d, normalizeClass as l, createElementVNode as w, renderSlot as b, createCommentVNode as i, withModifiers as p, createBlock as k, toDisplayString as H } from "vue";
import J from "./index7.js";
import M from "./index60.js";
const Q = {
  key: 0,
  class: "flex-shrink-0"
}, U = { class: "relative flex-1" }, W = ["value", "type", "name", "placeholder", "disabled", "readonly", "maxlength", "autocomplete", "inputmode", "lang"], X = {
  key: 1,
  class: "flex-shrink-0"
}, V = "text-input-text-static hover:text-input-text-hover cursor-pointer select-none rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1", te = /* @__PURE__ */ q({
  __name: "BaseInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: "" },
    size: { default: "md" },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    readonly: { type: Boolean, default: !1 },
    maxLength: {},
    userInputs: { default: () => [] },
    autocomplete: {},
    full: { type: Boolean, default: !1 },
    name: {},
    formatter: { type: Function, default: void 0 },
    allowSpaces: { type: Boolean, default: !1 },
    filter: { default: void 0 },
    textAlign: { default: "left" },
    errorMessageOverflow: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur", "onSearch"],
  setup(n, { expose: I, emit: P }) {
    const e = n, f = P, u = c(!1), x = c(e.modelValue || ""), g = c(!1), v = c(!1), h = c(0), C = s(
      () => e.variant === "search" || e.variant === "password" || e.variant === "password-strength"
    ), K = s(() => (e.variant === "password" || e.variant === "password-strength") && !u.value ? "password" : e.variant === "tel" ? "tel" : e.variant === "number" ? "number" : "text"), L = s(() => {
      if (e.variant === "password" || e.variant === "password-strength")
        return "text";
    }), A = s(() => {
      if (e.variant === "password" || e.variant === "password-strength")
        return "en";
    }), D = s(() => e.size === "sm" ? "px-[15px] py-[13px] text-[13px] leading-[16px]" : "px-[15px] py-[13px] text-[16px] leading-[20px]"), E = s(() => {
      const r = `relative ${e.full ? "w-full" : ""} rounded-md transition-all duration-150 flex bg-[var(--input-color-surface)] border border-solid`;
      return e.disabled ? `${r} bg-input-bg-disabled border-input-border-disabled text-input-text-disable cursor-not-allowed` : e.error ? `${r} border-input-border-error focus-within:border-input-border-error focus-within:shadow-[0_0_0_1px_var(--input-color-border-error)]` : `${r} border-input-border-static focus-within:border-input-border-focus focus-within:shadow-[0_0_0_1px_var(--input-color-border-focus)] hover:border-input-border-focus`;
    }), R = s(() => {
      const t = `w-full bg-transparent border-0 outline-none tracking-[-0.35px] ${D.value}`, r = C.value ? "pr-[45px]" : "", a = e.disabled ? "text-input-text-disable cursor-not-allowed placeholder:text-input-text-disable" : "text-input-text-static placeholder:text-input-text-placeholder placeholder:font-normal placeholder:tracking-[-0.35px]", m = e.textAlign === "right" ? "text-right pr-[24px] text-[20px] font-semibold py-[24px]" : e.textAlign === "center" ? "text-center" : "text-left", y = e.variant === "password" || e.variant === "password-strength" ? "ime-disabled" : "";
      return `${t} ${r} ${a} ${m} ${y}`;
    }), F = s(() => `flex items-center pl-[24px] text-input-text-static font-normal tracking-[-0.35px] ${e.size === "sm" ? "text-[13px] leading-[16px]" : "text-[16px] leading-[20px]"}`), $ = s(() => "absolute right-0 top-0 h-full flex items-center pr-[15px] gap-1"), N = s(() => {
      if (e.autocomplete !== void 0)
        return e.autocomplete;
      if (e.variant === "password" || e.variant === "password-strength")
        return "new-password";
      if (e.variant === "search")
        return "off";
    }), O = (t) => {
      t.key === " " && !e.allowSpaces && t.preventDefault();
    }, S = async (t) => {
      if (g.value)
        return;
      const r = t.target;
      let a = r.value;
      if (e.allowSpaces || (a = a.replace(/\s/g, ""), r.value = a), e.variant === "tel" && (a = a.replace(/[^0-9]/g, ""), r.value = a), e.maxLength && a.length > e.maxLength && (a = a.slice(0, e.maxLength), r.value = a), e.filter === "english" && (a = a.replace(/[^a-zA-Z]/g, ""), r.value = a), e.filter === "numeric" && (a = a.replace(/[^0-9.,]/g, ""), r.value = a), e.formatter && (a = e.formatter(a), r.value = a), x.value = a, f("update:modelValue", a), e.variant === "password-strength")
        if (!a)
          h.value = 0;
        else
          try {
            const { analyzePasswordStrength: m } = await import("@template/utils"), y = await m(a, e.userInputs);
            h.value = Math.max(0, Math.min(4, y.score));
          } catch (m) {
            console.warn("Password strength analysis failed:", m), h.value = 0;
          }
    }, T = () => {
      g.value = !0;
    }, Z = async (t) => {
      g.value = !1, await S(t), v.value && (v.value = !1, await new Promise((r) => setTimeout(r, 0)), f("onSearch", t));
    }, z = (t) => {
      if (t.key === "Enter" || t.key === " ") {
        if (g.value) {
          v.value = !0, t.preventDefault(), t.stopPropagation();
          return;
        }
        if (v.value) {
          v.value = !1, t.preventDefault(), t.stopPropagation();
          return;
        }
        f("onSearch", t);
      }
    }, j = (t) => {
      (t.key === "Enter" || t.key === " ") && (u.value = !u.value);
    };
    G(
      () => e.modelValue,
      (t) => {
        x.value = t || "";
      }
    );
    const B = c(null);
    return I({
      focus: () => {
        B.value?.focus();
      }
    }), (t, r) => (o(), d("div", {
      class: l(e.full ? "flex w-full flex-col" : "flex flex-col")
    }, [
      w("div", {
        class: l(e.full ? "flex w-full items-center gap-2" : "flex items-center gap-2")
      }, [
        t.$slots.prepend ? (o(), d("div", Q, [
          b(t.$slots, "prepend", {}, void 0, !0)
        ])) : i("", !0),
        w("div", {
          class: l([E.value, e.full ? "flex-1" : ""])
        }, [
          t.$slots["prepend-inner"] ? (o(), d("div", {
            key: 0,
            class: l(F.value)
          }, [
            b(t.$slots, "prepend-inner", {}, void 0, !0)
          ], 2)) : i("", !0),
          w("div", U, [
            w("input", {
              ref_key: "inputRef",
              ref: B,
              value: x.value,
              type: K.value,
              name: n.name,
              placeholder: n.placeholder,
              disabled: e.disabled,
              readonly: n.readonly,
              maxlength: n.maxLength,
              autocomplete: N.value,
              inputmode: L.value,
              lang: A.value,
              class: l(R.value),
              onKeydown: [
                p(z, ["stop"]),
                O
              ],
              onInput: S,
              onCompositionstart: T,
              onCompositionend: Z,
              onFocus: r[0] || (r[0] = (a) => f("focus", a)),
              onBlur: r[1] || (r[1] = (a) => f("blur", a))
            }, null, 42, W),
            C.value ? (o(), d("div", {
              key: 0,
              class: l($.value)
            }, [
              n.variant === "search" ? (o(), k(M, {
                key: 0,
                name: "search",
                size: n.size === "sm" ? "sm" : "md",
                class: l(V),
                tabindex: "0",
                role: "button",
                "aria-label": "검색 실행",
                onClick: r[2] || (r[2] = p((a) => f("onSearch", a), ["stop"])),
                onKeydown: p(z, ["stop"]),
                onMousedown: r[3] || (r[3] = p(() => {
                }, ["prevent"]))
              }, null, 8, ["size"])) : i("", !0),
              n.variant === "password" || n.variant === "password-strength" ? (o(), k(M, {
                key: 1,
                name: u.value ? "eye" : "eye-close",
                size: n.size === "sm" ? "sm" : "md",
                class: l(V),
                tabindex: "0",
                role: "button",
                "aria-label": u.value ? "비밀번호 숨기기" : "비밀번호 표시",
                onClick: r[4] || (r[4] = p((a) => u.value = !u.value, ["stop"])),
                onKeydown: p(j, ["stop"]),
                onMousedown: r[5] || (r[5] = p(() => {
                }, ["prevent"]))
              }, null, 8, ["name", "size", "aria-label"])) : i("", !0)
            ], 2)) : i("", !0)
          ]),
          t.$slots["append-inner"] ? (o(), d("div", {
            key: 1,
            class: l($.value.replace("gap-1", "z-10 gap-1"))
          }, [
            b(t.$slots, "append-inner", {}, void 0, !0)
          ], 2)) : i("", !0)
        ], 2),
        t.$slots.append ? (o(), d("div", X, [
          b(t.$slots, "append", {}, void 0, !0)
        ])) : i("", !0)
      ], 2),
      e.error && n.errorMessage ? (o(), d("div", {
        key: 0,
        class: l([
          "text-input-border-error mt-1 text-[12px] font-medium",
          e.errorMessageOverflow ? "whitespace-nowrap" : ""
        ])
      }, H(n.errorMessage), 3)) : i("", !0),
      n.variant === "password-strength" && x.value.length > 0 ? (o(), k(J, {
        key: 1,
        class: "mt-1",
        "strength-score": h.value,
        variant: "password-strength",
        "show-label": !0
      }, null, 8, ["strength-score"])) : i("", !0)
    ], 2));
  }
});
export {
  te as default
};
